import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, inject, isDevMode, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    PreloadAllModules,
    provideRouter,
    RouteReuseStrategy,
    withPreloading,
    withRouterConfig
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';

import { AppInitService, OwnHttpInterceptor, provideApiClient } from '@guardfinder/shared';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { AppComponent } from './app/app.component';
import { routes } from './app/routes/app.routes';
import { provideAuthGuardConfig } from './app/services/auth-guard/application/provide-auth-guard-config';
import { provideAppLoadProVersionCheck } from './app/services/guard-version-check/application/provide-app-load-pro-version-check';
import { provideRedirectStrategies } from './app/services/redirect-strategy/application/provide-redirect-strategies';
import { provideSvgIconService } from './app/services/svg-icons/application/provide-svg-icon-service';
import { Globals } from './app/shared/globals';
import { environment } from './environments/environment';
import { initSentry, provideSentry } from './sentry.provider';

if (environment.production) {
    enableProdMode();
    if (window) {
        /* eslint-disable @typescript-eslint/no-empty-function */
        window.console.log = function () {};
    }
}

initSentry();

export function initializeApp1(appInitService: AppInitService) {
    if (!isDevMode && 'serviceWorker' in navigator) {
        navigator.serviceWorker.register('/ngsw-worker.js');
    }

    return appInitService.Init('pro');
}

export function loadStorage(storage: Storage) {
    return storage;
}

bootstrapApplication(AppComponent, {
    providers: [
        { provide: 'environment', useValue: environment },
        { provide: 'globals', useClass: Globals },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.production
        }),
        importProvidersFrom(
            IonicStorageModule.forRoot(),
            CalendarModule.forRoot({
                provide: DateAdapter,
                useFactory: adapterFactory
            })
        ),
        provideAppInitializer(() => initializeApp1(inject(AppInitService))),
        {
            provide: 'storage',
            useFactory: loadStorage,
            deps: [Storage]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OwnHttpInterceptor,
            multi: true
        },
        provideIonicAngular({
            mode: 'md',
            useSetInputAPI: true
        }),
        provideRouter(
            routes,
            withPreloading(PreloadAllModules),
            withRouterConfig({ paramsInheritanceStrategy: 'always' })
        ),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideRedirectStrategies(),
        provideAuthGuardConfig(),
        provideAppLoadProVersionCheck(),
        provideSvgIconService(),
        provideSentry(),
        provideApiClient()
    ]
});
